import { createSlice } from "@reduxjs/toolkit";
import HemsireIsAramaKriterleri from "src/models/HemsireIsListesi/HemsireIsAramaKriterleri";
import VwHemsireIsListesiDTO from "src/models/HemsireIsListesi/VwHemsireIsListesiDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { GridFilterModel } from "@mui/x-data-grid-premium";
import { helper } from "src/utils/helper";
import HemsireIlacUygulamaRequests from "src/models/HemsireIsListesi/HemsireIlacUygulamaRequests";

interface IHemsireIsState {
  searchHandler: boolean;
  aramaKriterleri: HemsireIsAramaKriterleri;
  ilacUygulama: HemsireIlacUygulamaRequests;
  hemsireIsListe: Array<VwHemsireIsListesiDTO>;
  activeRow: VwHemsireIsListesiDTO;
  gridFilterModel: GridFilterModel;
  quickFilterValues: Array<any>;
}

export const HemsireIsSlice = createSlice<IHemsireIsState, MapReducerPayloads<IHemsireIsState, {
  setSearchHandler: boolean;
  setAramaKriterleri: HemsireIsAramaKriterleri;
  setIlacUygulama: HemsireIlacUygulamaRequests;
  setHemsireIsListe: Array<VwHemsireIsListesiDTO>;
  setActiveRow: VwHemsireIsListesiDTO;
  setGridFilterModel: GridFilterModel;
  setQuickFilterValues: Array<any>;
}>>({
  name: "hemsireIs",
  initialState: {
    searchHandler: false,
    aramaKriterleri: {
      ...new HemsireIsAramaKriterleri(),
      baslangicTarih: helper.datetimeToday(),
      bitisTarih: helper.datetimeToday()
    },
    hemsireIsListe: [],
    activeRow: new VwHemsireIsListesiDTO(),
    gridFilterModel: { items: [] },
    quickFilterValues: [],
    ilacUygulama: {
      ...new HemsireIlacUygulamaRequests(),
      uygulananTarih: helper.datetimeNow(),
      uygulamaDurumu:2,
    }
  },
  reducers: {
    setSearchHandler: (state, action) => {
      state.searchHandler = action.payload;
    },
    setAramaKriterleri: (state, action) => {
      state.aramaKriterleri = action.payload;
    },
    setHemsireIsListe: (state, action) => {
      state.hemsireIsListe = action.payload;
    },
    setActiveRow: (state, action) => {
      state.activeRow = action.payload;
    },
    setGridFilterModel: (state, action) => {
      state.gridFilterModel = action.payload;
    },
    setQuickFilterValues: (state, action) => {
      state.quickFilterValues = action.payload;
    },
      setIlacUygulama: (state, action) => {
      state.ilacUygulama = action.payload;
    },
  }
});
